import { ICache } from '../../search-page-interface';

export class Cache implements ICache {
	private readonly _cache: Map<string, unknown>;

	public constructor() {
		this._cache = new Map<string, unknown>();
	}

	public get<T>(key: string): T | null {
		const value = this._cache.get(key);
		if (value === undefined) {
			return null;
		}

		return value as T;
	}

	public set<T>(key: string, value: T): void {
		this._cache.set(key, value);
	}

	public remove(key: string): void {
		this._cache.delete(key);
	}
}
